var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDropdownModern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#folder-dropdown-modern_svg__clip0_1152_7885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.35.833h-5.1A1.137 1.137 0 014.463.49L4.088.187A2.443 2.443 0 002.963.074h-1.5C.525.074 0 .604 0 1.702V8.26c0 1.1.563 1.668 1.65 1.668h8.85c.938 0 1.5-.568 1.5-1.668V2.387c0-1.099-.562-1.554-1.65-1.554z",
    fill: "#61C8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "folder-dropdown-modern_svg__clip0_1152_7885"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .071)",
    d: "M0 0h12v9.857H0z"
  })))));
}
export default SvgFolderDropdownModern;